<template>
  <v-dialog :value="open" @click:outside="closeDialog()" scrollable max-width="500">
    <ValidationObserver ref="templateFormObs" v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ EditMode ? "Actualizar" : "Crear" }} plantilla
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 570px">
            <v-form>
              <v-row dense>
                <!-- Titulo -->
                <v-col cols="12">
                  <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Título"
                      name="name"
                      type="text"
                      color="blue-grey"
                      v-model="formData.title"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Client full name placeholder  -->
                <v-col cols="12">
                  <ValidationProvider name="Nombre de cliente" rules="required" v-slot="{ errors }">
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Nombre de cliente"
                      name="client_full_name_placeholder"
                      type="text"
                      color="blue-grey"
                      v-model="formData.client_full_name_placeholder"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Gateway -->
                <v-col cols="12" class="pb-0">
                  <ValidationProvider name="Gateway" rules="required" v-slot="{ errors }">
                    <v-autocomplete
                      :error-messages="errors"
                      :items="gatewayList"
                      :loading="isLoadingGateways"
                      item-text="name"
                      item-value="id"
                      label="Gateway"
                      class="rounded-small"
                      no-data-text="No hay gateways para mostrar"
                      rounded
                      filled
                      v-model="formData.gateway_id"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <!-- Config  -->
                <v-col cols="12">
                  <ValidationProvider name="Configuración" rules="required" v-slot="{ errors }">
                    <v-select
                      v-model="formData.config_id"
                      :loading="isLoadingConfig"
                      :items="whatsappList"
                      :error-messages="errors"
                      item-text="name"
                      item-value="id"
                      label="Configuración"
                      filled
                      rounded
                      class="rounded-small"
                    >
                      <template v-slot:item="{ item, on, attrs }">
                        <v-list-item two-line selectable v-on="on" v-bind="attrs" class="pl-3">
                          <template>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ item.name + " " }}
                              </v-list-item-title>

                              <v-list-item-subtitle>
                                {{ item.number }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-list-item>
                      </template>
                    </v-select>
                  </ValidationProvider>
                </v-col>

                <!-- Introduction -->
                <v-col cols="12">
                  <ValidationProvider name="Introducción" rules="required" v-slot="{ errors }">
                    <v-textarea
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Introducción"
                      type="text"
                      color="blue-grey"
                      v-model="formData.introduction"
                      :error-messages="errors"
                    >
                    </v-textarea>
                  </ValidationProvider>
                </v-col>

                <!-- Address -->
                <v-col cols="12">
                  <ValidationProvider name="Dirección" rules="required" v-slot="{ errors }">
                    <v-textarea
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Dirección"
                      type="text"
                      color="blue-grey"
                      v-model="formData.address"
                      :error-messages="errors"
                    >
                    </v-textarea>
                  </ValidationProvider>
                </v-col>

                <!-- Parameter (Combobox con Pills e interceptor de Pegado) -->
                <v-col cols="12">
                  <ValidationProvider name="parámetros" rules="required" v-slot="{ errors }">
                    <v-combobox
                      v-model="formData.parameter"
                      :error-messages="errors"
                      label="Parámetros"
                      filled
                      rounded
                      multiple
                      chips
                      deletable-chips
                      small-chips
                      hide-selected
                      append-icon=""
                      class="rounded-small"
                      hint="Presiona Enter para agregar o pega texto separado por comas o en formato array"
                      persistent-hint
                      @paste.native="handlePaste"
                    >
                    </v-combobox>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="closeDialog()">Cancelar</v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click.stop="handleSubmit(submitForm)"
            >
              {{ EditMode ? "Guardar" : "Crear" }}
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import vuescroll from "vuescroll";

export default {
  components: { vuescroll },
  props: {
    open: {
      type: Boolean,
    },
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      isLoadingGateways: false,
      isLoadingConfig: false,
      gatewayList: [],
      whatsappList: [],
      formData: {
        title: "",
        client_full_name_placeholder: "",
        introduction: "",
        address: "",
        config_id: undefined,
        gateway_id: undefined,
        parameter: [], // Ahora es un Array por defecto
      },
    };
  },

  computed: {
    EditMode() {
      return !!this.editData;
    },
  },

  watch: {
    open(val) {
      if (val) {
        this.getGateways();
        this.getWhatsappList();
        if (this.editData) {
          const {
            address,
            client_full_name_placeholder,
            title,
            introduction,
            config_id,
            gateway_id,
            parameter,
          } = this.editData;

          // Aseguramos que 'parameter' siempre se inicialice como un Array
          let parsedParameter = [];
          if (Array.isArray(parameter)) {
            parsedParameter = parameter;
          } else if (typeof parameter === "string" && parameter) {
            try {
              const parsed = JSON.parse(parameter);
              parsedParameter = Array.isArray(parsed) ? parsed : parameter.split(",").map((s) => s.trim());
            } catch (e) {
              parsedParameter = parameter.split(",").map((s) => s.trim());
            }
          }

          this.formData = {
            address,
            client_full_name_placeholder,
            title,
            introduction,
            config_id,
            gateway_id,
            parameter: parsedParameter,
          };
        }
      } else {
        this.resetForm();
      }
    },
  },

  methods: {
    resetForm() {
      this.formData = {
        title: "",
        client_full_name_placeholder: "",
        introduction: "",
        address: "",
        config_id: undefined,
        gateway_id: undefined,
        parameter: [],
      };
    },

    closeDialog(item) {
      this.$emit("dialog:close", item);
      if (this.$refs.templateFormObs) {
        this.$refs.templateFormObs.reset();
      }
    },

    // Procesa el pegado de texto en formato array `["a", "b"]` o separado por comas `a, b, c`
    handlePaste(event) {
      event.preventDefault();
      const pasteText = (event.clipboardData || window.clipboardData).getData("text");
      if (!pasteText) return;

      let items = [];

      try {
        // Intenta parsearlo si viene como JSON array: ["item1", "item2"]
        const parsed = JSON.parse(pasteText);
        if (Array.isArray(parsed)) {
          items = parsed.map((i) => String(i).trim());
        }
      } catch (e) {
        // Si falla el JSON parsing, lo dividimos por comas
        items = pasteText.split(",").map((i) => i.replace(/[\[\]'"]/g, "").trim());
      }

      // Filtramos vacíos y agregamos sin duplicar los existentes
      const validItems = items.filter((item) => item.length > 0);
      const currentParams = new Set(this.formData.parameter);
      validItems.forEach((item) => currentParams.add(item));

      this.formData.parameter = Array.from(currentParams);
    },

    async getGateways() {
      const page = 1;
      const itemPerPage = 100;
      this.isLoadingGateways = true;
      try {
        const { data } = await PbxHttpClient.get("/gateway", {
          params: { page, itemPerPage },
        });
        this.gatewayList = data.data;
      } catch (err) {
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
      this.isLoadingGateways = false;
    },

    async getWhatsappList() {
      this.isLoadingConfig = true;
      try {
        const { data } = await PbxHttpClient.get("/whatsapps/config/index_select");
        this.whatsappList = data;
      } catch (err) {
        this.$snotify.error("No se pudo obtener la lista de whatsapp", "¡Error!");
      }
      this.isLoadingConfig = false;
    },

    async submitForm() {
      this.isLoading = true;

      // Generamos el payload calculando dinámicamente parameter_number según el largo del array
      const payload = {
        ...this.formData,
        parameter_number: this.formData.parameter ? this.formData.parameter.length : 0,
      };

      let savedData;
      try {
        if (this.EditMode) {
          const { id } = this.editData;
          const { data } = await PbxHttpClient.put(`/module_appointment/templates_appointments/${id}`, payload);
          savedData = data;
          this.$snotify.success("Plantilla actualizada con exito", "¡Hecho!");
        } else {
          const { data } = await PbxHttpClient.post("/module_appointment/templates_appointments", payload);
          savedData = data;
          this.$snotify.success("Plantilla creada con exito", "¡Hecho!");
        }
        this.closeDialog(savedData);
      } catch (err) {
        this.$snotify.error("Hubo un error guardando la plantilla", "¡Error!");
      }
      this.isLoading = false;
    },
  },
};
</script>
